module.exports = __webpack_public_path__ + "img/henjiqingli.6d2b572d.png";